import { getAuthTokenClient } from '@/utils/helpers';
import {
  API_URLS,
  getJSONData,
  parseErrorMessage,
  TypeResponseError,
  TypeResponseSuccess,
} from '@/lib/api/config';
import { TypeUserRecord } from '@/lib/api/accountManager/types';

export type EditChildParams = {
  userUuid: string | undefined;
  childUuid: string;
  childName: string;
  childBirthDate: string;
  authToken?: string;
};

export async function editChild(params: EditChildParams) {
  const { userUuid, childUuid, childName, childBirthDate, authToken } = params;

  if (!userUuid || !childUuid || !childName || !childBirthDate) {
    console.warn('[editChild]: Missing Required Params');
  }

  const config = {
    method: 'PUT',
    headers: {
      Authorization: authToken ? authToken : await getAuthTokenClient(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      child: {
        name: childName?.trim(),
        birthday: childBirthDate,
      },
    }),
  };

  const response = await fetch(
    `${API_URLS.ACCOUNT_MANAGER_PROXY}/children/${childUuid}`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeResponseSuccess<TypeUserRecord>;
}
